import { useMemo } from "react";

const stripHtml = (value: string) => value.replace(/<[^>]*>/g, "");

const getFieldText = <T,>(item: T, key: keyof T): string => {
	const raw = item[key];
	if (raw == null) return "";
	return stripHtml(String(raw)).toLowerCase();
};

export function useLocalFilter<T>(
	values: T[],
	keys: (keyof T)[],
	searchValue: string,
): T[] {
	return useMemo(() => {
		const query = searchValue.trim().toLowerCase();
		if (!query) return values;
		return values.filter((item) =>
			keys.some((key) => getFieldText(item, key).includes(query)),
		);
	}, [values, keys, searchValue]);
}
